import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExclusionDal } from '../dal/exclusion.dal';
import { Exclusion } from '../models/exclusion.model';

@Injectable({
  providedIn: 'root',
})
export class ExclusionService {
  constructor(private exclusionDal: ExclusionDal) {}

  getAllExclusions(): Observable<any[]> {
    return this.exclusionDal.getAllExclusions();
  }

  getExclusions(profileId: string, isIndividualJobDescription: boolean, hospital: string): Observable<any[]> {
    return this.exclusionDal.getExclusions(profileId, isIndividualJobDescription, hospital);
  }

  modifyExclusions(exclusions: Exclusion[]): Observable<any[]> {
    return this.exclusionDal.modifyExclusions(exclusions);
  }

  deleteExclusions(exclusionId: string) {
    return this.exclusionDal.deleteExclusions(exclusionId);
  }

  deleteManyExclusions(exclusionIds: string[]) {
    return this.exclusionDal.deleteManyExclusions(exclusionIds);
  }

  addExclusions(exclusions: any[]) {
    return this.exclusionDal.addExclusions(exclusions);
  }
}
